import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Badge, Button, Card, Col, Container, Dropdown, Form, Modal, Row, Table } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import { getSchoolBySelection } from '../../actions/schoolsActions'
import { getSelection } from '../../actions/selectionsActions'
import SubMenuSelection from '../../components/menus/SubMenuSelection'
import { addChoose, dimissCandidate, getChoosesBySelection, getInterviewsCalendarBySchool, scheduleInterview, viewVideo, removeChoose, sendOfferLetter, addIncorporationDate } from '../../actions/choosesActions'
import Swal from 'sweetalert2'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction"
import '@fullcalendar/bootstrap5/main.css'
import '@fullcalendar/daygrid/main.css'
import esLocale from '@fullcalendar/core/locales/es'
import { getCourseSubjects, getLevels } from '../../actions/miscellaneousActions'
import CandidateProfile from '../admin/CandidateProfile'
import { editMultiSchoolStock, editStock, getReducedStocksBySchool } from '../../actions/stocksActions'
import { PDFViewer } from '@react-pdf/renderer'
import OfferLetter from '../../components/pdfs/OfferLetter'

export default function CandidatesSelection() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const params = useParams()
    const dispatch = useDispatch()
    const calendar = useRef(null)

    const {school, schooluser} = useSelector(state=>state.schools)
    const {selection, candidatesLoading} = useSelector(state=>state.selections)
    const {chooses, result, loading, schedule} = useSelector(state => state.chooses)
    const {levels, subjects} = useSelector(state => state.miscellaneous)
    const {result: stocksResult, stocks} = useSelector(state => state.stocks)

    const [selectedCandidate, setSelectedCandidate] = useState(null)
    const [dimissReason, setDimissReason] = useState(null)
    const [dimissReasonDescription, setDimissReasonDescription] = useState(null)
    const [selectedVideo, setSelectedVideo] = useState(null)
    const [interviewSelectedChoose, setInterviewSelectedChoose] = useState(null)
    const [selectedInterviewDate, setSelectedInterviewDate] = useState(null)
    const [selectedInterviewTime, setSelectedInterviewTime] = useState(null)
    const [interviewDates, setInterviewDates] = useState([])
    const [selectedEvent, setSelectedEvent] = useState(null)
    const [selectedCandidateProfile, setSelectedCandidateProfile] = useState(null)

    const [offerLetterSelectedChoose, setOfferLetterSelectedChoose] = useState(null)
    const [offerLetterData, setOfferLetterData] = useState({
        sexualCrimeCertification: true,
        step: 1
    })

    const [incorporationDateSelectedChoose, setIncorporationDateSelectedChoose] = useState(null)
    const [incorporationDate, setIncorporationDate] = useState(null)
    const [incorporationHour, setIncorporationHour] = useState(null)

    const [multiSchoolStockForm, setMultiSchoolStockForm] = useState(null)

    const onModalClose = () => {
        setSelectedCandidate(null)
        setDimissReason(null)
        setDimissReasonDescription(null)
    }

    const handleDimissSubmit = () => {
        if (selectedCandidate && dimissReason) {
            dispatch(dimissCandidate(selectedCandidate._id, dimissReason, dimissReasonDescription || t("selection.dimiss." + dimissReason + "Description", {name: `${selectedCandidate?.candidate?.firstname} ${selectedCandidate?.candidate?.lastname}`})))
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: t('selection.dimiss.formError')
            });
        }
    }

    const handleVideoClick = (choose) => {
        if (choose.videoPresentation) {
            setSelectedVideo(choose)
            dispatch(viewVideo(choose._id))
        }
    }

    const handleInterviewModalClose = () => {
        setInterviewSelectedChoose(null)
        setInterviewDates([])
        closeInterviewDate()
    }

    const handleInterviewDateClick = (arg) => {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const clickedDate = new Date(arg.date)
        clickedDate.setHours(0, 0, 0, 0)
    
        if (interviewDates.length < 3 && clickedDate >= today) {
            setSelectedInterviewDate(arg);
        }
    }

    const closeInterviewDate = () => {
        setSelectedInterviewTime(null)
        setSelectedInterviewDate(null)
    }

    const saveInterviewDate = () => {
        if (selectedInterviewTime) {
            setInterviewDates([
                ...interviewDates,
                {
                    date: selectedInterviewDate.date,
                    hour: selectedInterviewTime
                }
            ])
            closeInterviewDate()
        }
    }

    const handleEventClick = (e) => {
        if (e.event._def?.extendedProps?.type === "choose") {
            Swal.fire({
                icon: 'question',
                showCancelButton: true,
                showConfirmButton: true,
                text: t('selection.deleteInterviewDayQuestion'),
                cancelButtonText: t('global.cancel'),
                confirmButtonText: t('global.yes')
            }).then(result => {
                if (result.isConfirmed) {
                    setInterviewDates(interviewDates.filter((value, index) => index !== e.event._def.extendedProps.index))
                }
            })
        } else {
            setSelectedEvent(e.event._def?.extendedProps)
        }
    }

    const handleInterviewSave = () => {
        if (interviewDates.length === 3) {
            dispatch(scheduleInterview(interviewSelectedChoose._id, interviewDates))
        }else{
            Swal.fire({
                icon: 'warning',
                title: '',
                text: t('selection.enoughDates')
            });
        }
    }

    const handleCandidateInterviewClick = (candidate) => {
        setInterviewSelectedChoose(candidate)
        if (candidate.schedule && candidate.schedule.length < (selection?.interviews?.length || 0)) {
            setInterviewDates(candidate.schedule[candidate.schedule.length - 1 > -1 ? candidate.schedule.length - 1 : 0].days.map(s => {
                return {
                    date: new Date(s.date),
                    hour: s.hour
                }
            }))
        }
    }

    const capitalizeFirstCharacter = (string) => {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        } else {
            return ''
        }
    }

    const handleEditStock = (candidate, movement) => {
        if (client?.rol === "MultiSchool") {
            let typeMovement = ''
            let typeStock = ''

            if(movement === 'addFavourite'){
                typeMovement = 'add'
                typeStock = 'favourite'
            }else if(movement === 'removeFavourite'){
                typeMovement = 'remove'
                typeStock = 'favourite'
            }else if(movement === 'addBlocked'){
                typeMovement = 'add'
                typeStock = 'blocked'
            }
            setMultiSchoolStockForm({
                movement: typeMovement,
                typeStock: typeStock,
                scope: 'all',
                candidate: candidate._id,
            })
        } else {
            let typeMovement = ''
            let typeStock = ''
            let swalText = ''
    
            if(movement === 'addFavourite'){
                typeMovement = 'add'
                typeStock = 'favourite'
                swalText = t('database.addFavouriteCandidateQuestion')
            }else if(movement === 'removeFavourite'){
                typeMovement = 'remove'
                typeStock = 'favourite'
                swalText = t('database.removeFavouriteCandidateQuestion')
            }else if(movement === 'addBlocked'){
                typeMovement = 'add'
                typeStock = 'blocked'
                swalText = t('database.addBlockCandidateQuestion')
            }
    
            Swal.fire({
                showConfirmButton: true,
                showDenyButton: true,
                confirmButtonText: t('global.confirm'),
                denyButtonText: t('global.cancel'),
                icon: 'question',
                text: t(swalText, {name: `${candidate.firstname} ${candidate.lastname}`})
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(editStock(school?._id, candidate._id, typeStock, typeMovement))
                }
            })
        }
    }

    useEffect(() => {
        if(client){
            dispatch(getSchoolBySelection(params.id))
            dispatch(getLevels())
            dispatch(getCourseSubjects())
        }
    },[dispatch, t, client])

    useEffect(() => {
        if(school){
            dispatch(getSelection(params.id))
            dispatch(getInterviewsCalendarBySchool(school._id))
            dispatch(getReducedStocksBySchool(school?._id))
        }
    },[school, dispatch, params.id])

    const addCandidate = (choose) => {
        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.confirm'),
            denyButtonText: t('global.cancel'),
            icon: 'question',
            text: t('selection.addCandidateQuestion', {name: `${choose.candidate.firstname} ${choose.candidate.lastname}`})
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeChoose(choose._id, false))
                dispatch(addChoose(params.id, choose.candidate._id, 'candidate'))
            }
        })
    }

    const handleRemoveChoose = (choose) => {
        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.confirm'),
            denyButtonText: t('global.cancel'),
            icon: 'question',
            text: t('selection.addToPrecandidatesQuestion', {name: `${choose.candidate?.firstname} ${choose.candidate?.lastname}`})
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeChoose(choose._id, true))
            }
        })
    }

    const handleOfferLetterModalClose = () => {
        setOfferLetterSelectedChoose(null)
        setOfferLetterData({
            sexualCrimeCertification: true,
            step: 1
        })
    }

    const handleSendOfferLetter = () => {
        dispatch(sendOfferLetter(offerLetterSelectedChoose._id, offerLetterData))
    }

    const handleIncorporationDateModalClose = () => {
        setIncorporationDateSelectedChoose(null)
        setIncorporationDate(selection?.incorporationDate ? `${new Date(selection.incorporationDate).getFullYear()}-${String(new Date(selection.incorporationDate).getMonth() + 1).padStart(2, "0")}-${String(new Date(selection.incorporationDate).getDate()).padStart(2, "0")}` : null)
        setIncorporationHour(null)
    }

    const handleCloseStockModal = () => {
        setMultiSchoolStockForm(null)
    }

    const handleSetIncorporationDate = () => {
        dispatch(addIncorporationDate(incorporationDateSelectedChoose._id, incorporationDate, incorporationHour))
    }

    const handleOfferLetterSwitchChange = ({target}) => {
        setOfferLetterData({...offerLetterData, [target.name]: target.checked})
    }

    const handleOfferLetterChange = ({target}) => {
        setOfferLetterData({...offerLetterData, [target.name]: target.value})
    }

    const handleStockSubmit = (e) => {
        e.preventDefault()
        const formStateCopy = {...multiSchoolStockForm, multiSchool: client?.id}

        if (formStateCopy.scope === "current") {
            formStateCopy.school = school?._id
        }

        dispatch(editMultiSchoolStock(formStateCopy))
    }

    useEffect(() => {
        if(result){
            dispatch({ type: 'CHOOSE_RESET_RESULT' })
            switch (result) {
                case 'successaddchoose':
                    setSelectedCandidateProfile(null)
                    dispatch(getChoosesBySelection(params.id))
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('selection.successaddchoose')
                    })
                    break;
                case 'successarchive':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('selection.successarchive')
                    })
                    break;
                case 'ok':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('selection.succesremovearchive')
                    })
                case 'dimissCandidateSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('selection.dimiss.dimissCandidateSuccess')
                    })
                    setSelectedCandidate(null)
                    setDimissReason(null)
                    setDimissReasonDescription(null)
                    break;
                case 'successNewScheduleInterview':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('selection.successNewScheduleInterview')
                    })
                    dispatch(getInterviewsCalendarBySchool(school._id))
                    dispatch(getChoosesBySelection(params.id))
                    setInterviewSelectedChoose(null)
                    setInterviewDates([])
                    setSelectedInterviewTime(null)
                    setSelectedInterviewDate(null)
                    break;
                case 'chooseSendOfferLetterSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('selection.chooseSendOfferLetterSuccess')
                    })
                    setOfferLetterSelectedChoose(null)
                    setOfferLetterData({
                        sexualCrimeCertification: true,
                        step: 1
                    })
                    dispatch(getChoosesBySelection(params.id))
                break;
                case 'setIncorporationDateSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('selection.setIncorporationDateSuccess')
                    })
                    dispatch(getChoosesBySelection(params.id))
                    setIncorporationDateSelectedChoose(null)
                    setIncorporationDate(selection?.incorporationDate ? `${new Date(selection.incorporationDate).getFullYear()}-${String(new Date(selection.incorporationDate).getMonth() + 1).padStart(2, "0")}-${String(new Date(selection.incorporationDate).getDate()).padStart(2, "0")}` : null)
                    setIncorporationHour(null)
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    },[result, t, dispatch, school, params])

    useEffect(() => {
        if (stocksResult === "successAddFavourite" || stocksResult === "successRemoveFavourite") {
            dispatch(getReducedStocksBySchool(school?._id))
            setMultiSchoolStockForm(null)
        }
        if (stocksResult === "successAddBlocked") {
            dispatch(getReducedStocksBySchool(school?._id))
            setSelectedCandidateProfile(null)
            dispatch(getChoosesBySelection(params.id))
            setMultiSchoolStockForm(null)
        }
    }, [stocksResult, dispatch, school])

    useEffect(() => {
        if (selection) {
            setIncorporationDate(selection?.incorporationDate ? `${new Date(selection.incorporationDate).getFullYear()}-${String(new Date(selection.incorporationDate).getMonth() + 1).padStart(2, "0")}-${String(new Date(selection.incorporationDate).getDate()).padStart(2, "0")}` : null)
        }
    }, [selection])

    return (
        <>
            <Container className='cuerpo'>
                <Row className="mb-5">
                    <Col className='d-flex align-items-center'>
                        <img src="/images/config.svg" alt="Icono Configuración" />
                        <h1 className='ms-2 m-0'>{t('menus.activeSelection')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra lateral'>
                            <Card.Body className='p-5'>
                                <SubMenuSelection selection={selection} section="candidates"/>
                                <Row className='my-3'>
                                    <Col xs={10}>
                                        <div className='d-flex align-items-center'>
                                            <img src="/images/titles-filled.svg" alt="Icono titulos" />
                                            <h4 className='ms-2 m-0'>{t('selection.candidates')} <span className="color-primary">({chooses?.filter(c => c?.type !== 'archive' && c.candidateStatus !== 2 && c.candidateOfferLetterStatus !== 2)?.length || 0})</span></h4>
                                        </div>
                                    </Col>
                                </Row>
                                {/* Candidatos pendientes y aceptados */}
                                <Row className='my-3'>
                                    <Col className='my-3'>
                                        {
                                            chooses?.filter(c => c.type !== 'archive' && c.candidateStatus !== 2 && c.candidateOfferLetterStatus !== 2)?.length > 0
                                            ?
                                            <Table className='selection'>
                                                <thead>
                                                    <tr>
                                                        <th>{t('school.selection.name')}</th>
                                                        <th className='text-center' style={{width: '150px'}}>{t('school.selection.affinity')}</th>
                                                        <th className='text-center' style={{width: '150px'}}>{t('school.selection.status')}</th>
                                                        <th className='text-center' style={{width: '150px'}}>{t('selection.interview')}</th>
                                                        { selection?.videoPresentation &&
                                                            <th className='text-center'>{t('school.selection.video')}</th>
                                                        }
                                                        <th className='bg-grey text-center' style={{width: '150px'}}>{t('global.actions')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        chooses?.filter(c => c.type !== 'archive' && c.candidateStatus !== 2 && c.candidateOfferLetterStatus !== 2)?.map((choose, index) => (
                                                            <Fragment key={index}>
                                                                <tr className={choose.incorporationDate?.date ? 'bg-light-primary' : ''}>
                                                                    <td>
                                                                        <Link to={`/school/overviewprocess/${selection?._id}/candidates/${choose._id}`} className='text-decoration-none text-dark d-flex align-items-center'>
                                                                            <div className='avatar-mini list me-2'>
                                                                                <div className='img-profile' style={{backgroundImage: `url(${choose.user?.image ? choose.user.image : "/images/avatar-empty.svg"})`}}/>
                                                                            </div>
                                                                            { choose.candidate.firstname } { choose.candidate.lastname }
                                                                        </Link>
                                                                    </td>
                                                                    <td className='align-middle text-center'>
                                                                        <div className={`pildora draft ${choose.porcentage > 85 ? 'bg-high' : (choose.porcentage >= 60 ? 'bg-medium' : 'bg-low')}`}>{choose.porcentage}%</div>
                                                                    </td>
                                                                    <td className='align-middle text-center'>
                                                                        {
                                                                            choose.candidateStatus === 0
                                                                            ?
                                                                                <div className='pildora draft'>{t('selection.chooseStatus.pending')}</div>
                                                                            :
                                                                                choose.incorporationDate?.date
                                                                                ?
                                                                                    <div className='pildora bg-orange text-white'>{t('selection.chooseStatus.hired')}</div>
                                                                                :
                                                                                    <div className='pildora published'>{t('selection.chooseStatus.accepted')}</div>
                                                                        }
                                                                    </td>
                                                                    <td className='align-middle text-center'>
                                                                        {
                                                                            choose.candidateStatus !== 2 && (!choose.schedule || choose.schedule.length === 0 || !choose.schedule[choose.schedule.length - 1]?.days || choose.schedule[choose.schedule.length - 1]?.days?.length > 1 || choose.schedule[choose.schedule.length - 1]?.days?.length === 0)
                                                                            ?
                                                                                <div className='pildora draft'>{t('selection.chooseStatus.pending')}</div>
                                                                            :
                                                                                choose.schedule && choose.schedule.length > 0 && choose.schedule[choose.schedule.length - 1].days[0]?.date && new Date(choose.schedule[choose.schedule.length - 1].days[0].date) > new Date()
                                                                                ?
                                                                                    <div className='pildora draft'>{t('selection.chooseStatus.scheduled')}</div>
                                                                                :
                                                                                    <div className='pildora draft'>{t('selection.chooseStatus.done')}</div>
                                                                        }
                                                                    </td>
                                                                    { selection?.videoPresentation &&
                                                                        <td className='align-middle text-center'>
                                                                            {
                                                                                choose?.videoSaw
                                                                                ?
                                                                                    <img src="/images/video-viewed.svg" alt='Vídeo' className='cursor' onClick={() => {handleVideoClick(choose)}}/>
                                                                                :
                                                                                    <img src="/images/video.svg" alt='Vídeo' className={choose.videoPresentation ? 'cursor' : 'muted'} onClick={() => {handleVideoClick(choose)}}/>
                                                                            }
                                                                        </td>
                                                                    }
                                                                    <td className='bg-grey align-middle'>
                                                                        {
                                                                            !choose.incorporationDate?.date &&
                                                                            <Dropdown drop='start' className='h-100 text-center'>
                                                                                <Dropdown.Toggle as="img" src="/images/options.svg" className='cursor muted'/>
                                                                                {
                                                                                    choose.schedule?.comment &&
                                                                                    <div className='notification-dot bg-danger mx-2'/>
                                                                                }
                                                                                <Dropdown.Menu>
                                                                                    <Dropdown.Item as="div" className='cursor' onClick={() => setSelectedCandidate(choose)}>
                                                                                        {t("selection.dimissCandidate")}
                                                                                    </Dropdown.Item>
                                                                                    {/* {
                                                                                        choose.candidateStatus === 1 && (!choose.schedule?.days || choose.schedule?.days?.length === 0) &&
                                                                                        <Dropdown.Item as="div" className='cursor d-flex' onClick={() => handleCandidateInterviewClick(choose)}>
                                                                                            {t("selection.proposeInterview")}
                                                                                            {
                                                                                                choose.schedule?.comment &&
                                                                                                <div className='notification-dot bg-danger mx-2'/>
                                                                                            }
                                                                                        </Dropdown.Item>
                                                                                    }
                                                                                    {
                                                                                        choose.candidateStatus === 1 && (choose.schedule?.days?.length === 1 && new Date(choose.schedule.days[0].date) <= new Date()) && !choose.offerLetter &&
                                                                                        <Dropdown.Item as="div" className='cursor d-flex' onClick={() => setOfferLetterSelectedChoose(choose)}>
                                                                                            {t("selection.proposeOfferLetter")}
                                                                                        </Dropdown.Item>
                                                                                    }
                                                                                    {
                                                                                        choose.candidateStatus === 1 && (choose.schedule?.days?.length === 1 && new Date(choose.schedule.days[0].date) <= new Date()) && choose.offerLetter && choose.candidateOfferLetterStatus === 1 && !choose.incorporationDate?.date && 
                                                                                        <Dropdown.Item as="div" className='cursor d-flex' onClick={() => setIncorporationDateSelectedChoose(choose)}>
                                                                                            {t("selection.setIncorporationDate")}
                                                                                        </Dropdown.Item>
                                                                                    } */}
                                                                                </Dropdown.Menu>
                                                                            </Dropdown>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                                {/* <tr key={index+'-b'}>
                                                                    <InterviewSection choose={choose} nameSend={school?.name} typeuser={'School'} t={t} />
                                                                </tr> */}
                                                            </Fragment>
                                                        ))
                                                    }
                                                </tbody>
                                            </Table>
                                            :
                                            <div className='text-center'>{t('school.selection.nocandidates')}</div>
                                        }
                                    </Col>
                                    {
                                        candidatesLoading &&
                                        <div className='text-center'>
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </div>
                                    }
                                </Row>
                                {/* Candidatos archivados */}
                                <Row className='my-3'>
                                    <Col xs={10}>
                                        <div className='d-flex align-items-center'>
                                            <img src="/images/titles-filled.svg" alt="Icono titulos" />
                                            <h4 className='ms-2 m-0'>{t('selection.archive')} <span className="color-primary">({chooses?.filter(c => c.type === 'archive')?.length || 0})</span></h4>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='my-3'>
                                    <Col className='my-3'>
                                        {chooses?.filter(c => c.type === 'archive').length > 0
                                        ?
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>{t('school.selection.name')}</th>
                                                    <th className='text-center' style={{width: '150px'}}>{t('school.selection.affinity')}</th>
                                                    <th style={{width: '150px'}}>{t('school.selection.annotations')}</th>
                                                    <th className='bg-grey text-center' style={{width: '150px'}}>{t('global.actions')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    chooses?.filter(c => c.type === 'archive')?.map((choose, index) => (
                                                        <tr key={index}>
                                                            <td className='d-flex align-items-center'>
                                                                <div className='avatar-mini list cursor me-2' onClick={() => setSelectedCandidateProfile(choose)}>
                                                                    <div className='img-profile' style={{backgroundImage: `url(${choose.user?.image ? choose.user.image : "/images/avatar-empty.svg"})`}}/>
                                                                </div>
                                                                { choose.candidate.firstname } { choose.candidate.lastname }
                                                            </td>
                                                            <td className='align-middle text-center'><Badge className={`porcentaje ${choose.porcentage > 85 ? 'bg-high' : (choose.porcentage >= 60 ? 'bg-medium' : 'bg-low')}`}>{choose.porcentage}%</Badge></td>
                                                            <td className='align-middle'></td>

                                                            <td className='bg-grey align-middle'>
                                                                <Dropdown drop='start' className='h-100 text-center'>
                                                                    <Dropdown.Toggle as="img" src="/images/options.svg" className='cursor'/>
                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item as="div" className='cursor' onClick={() => addCandidate(choose)}>
                                                                            {t("selection.addToProcess")}
                                                                        </Dropdown.Item>
                                                                        <Dropdown.Item as="div" className='cursor' onClick={() => handleRemoveChoose(choose)}>
                                                                            {t("selection.addToPrecandidates")}
                                                                        </Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                        :
                                        <div className='text-center'>{t('school.selection.nocandidates')}</div>
                                        }
                                    </Col>
                                    {
                                        candidatesLoading &&
                                        <div className='text-center'>
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </div>
                                    }
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal size='lg' show={selectedCandidate ? true : false} onHide={onModalClose} >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("selection.candidateDimissTitle", {name: `${selectedCandidate?.candidate?.firstname} ${selectedCandidate?.candidate?.lastname}`})}
					</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='my-3'>
                        <Form.Label>{t("selection.dimissReason")}</Form.Label>
                        <Form.Select value={dimissReason || "null"} onChange={({target}) => setDimissReason(target.value)}>
                            <option value="null" disabled>{t("global.selectOption")}</option>
                            {["noRequisites", "noCulture", "chooseAnotherOne", "genericDimiss"].map((reason, index) => (
                                <option value={reason} key={index}>{t("selection.dimiss." + reason)}</option>
                            ))}
                        </Form.Select>
                    </div>
                    {
                        dimissReason &&
                        <div className='my-3'>
                            <Form.Label>{t("selection.dimissReason")}</Form.Label>
                            <Form.Control as="textarea" value={dimissReasonDescription || t("selection.dimiss." + dimissReason + "Description", {name: `${selectedCandidate?.candidate?.firstname} ${selectedCandidate?.candidate?.lastname}`})} onChange={({target}) => setDimissReasonDescription(target.value)} rows={6}/>
                        </div>
                    }
                    <div className='my-3'>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onModalClose}>{t("global.cancel")}</Button>
                    <Button variant="primary" onClick={handleDimissSubmit}>
                        {
                            loading
                            ?
                                <span className="spinner-border spinner-border-sm align-middle ms-2"/>
                            :
                                t("global.save")
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal size='xl'show={selectedVideo ? true : false} onHide={() => setSelectedVideo(null)}>
                <Modal.Header closeButton />
                <Modal.Body>
                    {
                        selectedVideo?.videoPresentation &&
                        <video src={selectedVideo.videoPresentation} controls className='w-100'/>
                    }
                </Modal.Body>
            </Modal>
            <Modal size='xl' show={interviewSelectedChoose ? true : false} onHide={handleInterviewModalClose}>
                <Modal.Header closeButton>
                    <h3>{t('selection.manageCandidateInterview', {name: `${interviewSelectedChoose?.candidate?.firstname} ${interviewSelectedChoose?.candidate?.lastname}`})}</h3>
                </Modal.Header>
                <Modal.Body>
                    {
                        interviewSelectedChoose?.schedule?.comment &&
                        <div>
                            <div className='fw-bold'>{t("selection.candidateComment")}</div>
                            {interviewSelectedChoose?.schedule?.comment.split("\n").map((paragraph, index) => (
                                <p key={index}>{paragraph}</p>
                            ))}
                        </div>
                    }
                    <h4 className='mb-4 text-center'>{t('selection.propose3Dates')}</h4>
                    <FullCalendar
                        displayEventTime={false}
                        ref={calendar}
                        height={'auto'}
                        fixedWeekCount={false}
                        locale={esLocale}
                        weekends={true}
                        plugins={[dayGridPlugin, interactionPlugin]}
                        headerToolbar={{
                            start: 'prev',
                            center: 'title',
                            end: 'next',
                        }}
                        dateClick={handleInterviewDateClick}
                        events={schedule?.map(s => {
                            if(s.choose._id === interviewSelectedChoose?._id) {
                                return null
                            } else {
                                let eventDate = new Date(s.day)
                                eventDate.setHours(s.hour?.split(':')[0])
                                eventDate.setMinutes(s.hour?.split(':')[1])
                                return {...s, title: `${s.candidate} (${s.hour})`, start: eventDate, classNames: ['text-body'], color: s.accepted ? 'green' : 'orange'}
                            }
                        })?.filter(s => s !== null)?.concat(interviewDates.map((d, dIndex) => {
                            let eventDate = d.date
                            eventDate.setHours(d.hour?.split(':')[0])
                            eventDate.setMinutes(d.hour?.split(':')[1])
                            return {title: `${interviewSelectedChoose.candidate.firstname} ${interviewSelectedChoose.candidate.lastname} (${d.hour})`, start: eventDate, classNames: ['text-body'], type: 'choose', index: dIndex}
                        }))}
                        eventClick={handleEventClick}
                    />
                    <Row className='my-3'>
                        <Col className='d-flex justify-content-end'>
                            <Button variant='secondary' className='me-2' onClick={handleInterviewModalClose}>{t('global.cancel')}</Button>
                            <Button variant='primary' onClick={handleInterviewSave}>{t('global.save')}</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal centered={true} show={selectedInterviewDate ? true : false} onHide={closeInterviewDate}>
                <Modal.Header closeButton>
                        {
                            selectedInterviewDate
                            ?
                                <h4>
                                    {new Intl.DateTimeFormat('es-ES', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(selectedInterviewDate.date)}
                                </h4>
                            :
                                ''
                        }
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>{t("dashboard.candidate.hour")}</Form.Label>
                    <Form.Control type='time' value={selectedInterviewTime || ''} onChange={({target}) => setSelectedInterviewTime(target.value)}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' type='button' onClick={closeInterviewDate}>{t('global.cancel')}</Button>
                    <Button variant='primary' type='button' onClick={saveInterviewDate}>{t('global.save')}</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={selectedEvent ? true : false} onHide={() => setSelectedEvent(null)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        { selectedEvent?.choose?.selection?.title }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("school.selection.candidate")}
                            <small>{selectedEvent?.choose?.candidate?.firstname || ''} {selectedEvent?.choose?.candidate?.lastname || ''}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("school.selection.datetime")}
                            <small>{selectedEvent?.day ? new Date(selectedEvent?.day).toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year: 'numeric'}) : ''} {selectedEvent?.hour || ''}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.specialty")}
                            <small>{capitalizeFirstCharacter(levels?.find(l => l.id === selectedEvent?.choose?.selection?.specialty)?.label)}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t(selectedEvent?.choose?.selection?.specialty == 1 ? "profile.candidate.position" : "selection.subject")}
                            <small>{t("subjects." + subjects?.find(s => s.id === selectedEvent?.choose?.selection?.subject)?.label)}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.shortIncorporationDate")}
                            <small>{`${String(new Date(selectedEvent?.choose?.selection?.incorporationDate).getDate()).padStart(2, '0')}/${String(new Date(selectedEvent?.choose?.selection?.incorporationDate).getMonth() + 1).padStart(2, '0')}/${new Date(selectedEvent?.choose?.selection?.incorporationDate).getFullYear()}`}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.salary")}
                            <small>{selectedEvent?.choose?.selection?.salary || t("selection.byAgreement")}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.contractType")}
                            <small>{t("profile.candidate." + selectedEvent?.choose?.selection?.contractType)}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("profile.candidate.idealPosition.workDay.label")}
                            <small>{t("profile.candidate.idealPosition.workDay." + selectedEvent?.choose?.selection?.workdayType)}</small>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={selectedCandidateProfile ? true : false} dialogClassName="modal-90w" aria-labelledby="example-custom-modal-styling-title" centered>
                <Modal.Header>
                    <Modal.Title id="example-custom-modal-styling-title" className='w-100 d-flex justify-content-end'>
                        <div>
                            <i className='fa fa-times cursor' onClick={() => setSelectedCandidateProfile(null)}></i>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CandidateProfile candidateToShow={{iduser: selectedCandidateProfile?.user?._id}} affinity={selectedCandidateProfile?.porcentage} actions={{favourite: handleEditStock, block: selectedCandidateProfile?.type === 'archive' ? handleEditStock : null, add: () => {if(!chooses?.find(c => c.candidate === selectedCandidateProfile?.candidate._id)){addCandidate(selectedCandidateProfile?.candidate)}}}} favourite={stocks.some(stock => stock.candidate === selectedCandidateProfile?.candidate?._id && stock.type.includes("favourite")) ? true : false} selectedCandidate={selectedCandidateProfile} selection={params.id}/>
                </Modal.Body>
                {
                    selectedCandidateProfile?.type === 'archive' &&
                    <Modal.Footer>
                        <div>
                            <Button
                                variant='success'
                                className='d-flex align-items-center justify-content-center flex-grow-1 ms-2'
                                onClick={() => {
                                    if(selectedCandidateProfile?.type === 'archive'){
                                        addCandidate(selectedCandidateProfile)}
                                    }
                                }
                            >
                                <img src='/images/plus-white.svg' alt='Añadir' className='me-2'/>
                                {t('global.add')}
                            </Button>
                        </div>
                    </Modal.Footer>
                }
            </Modal>
            <Modal size='xl' show={offerLetterSelectedChoose ? true : false} onHide={handleOfferLetterModalClose}>
                <Modal.Header className='px-5 pt-4' closeButton>
                    <h3>{t('selection.candidateOfferLetter', {name: `${offerLetterSelectedChoose?.candidate?.firstname} ${offerLetterSelectedChoose?.candidate?.lastname}`})}</h3>
                </Modal.Header>
                <Modal.Body className='p-5'>
                    {
                        offerLetterData.step === 1 &&
                        <>
                            <div>
                                {t('selection.candidateOfferLetterQuestion', {name: `${offerLetterSelectedChoose?.candidate?.firstname} ${offerLetterSelectedChoose?.candidate?.lastname}`})}
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.dni')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="dni"
                                    id="dni"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.dni}
                                />
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.socialSecurity')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="socialSecurity"
                                    id="socialSecurity"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.socialSecurity}
                                />
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.bankAccount')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="bankAccount"
                                    id="bankAccount"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.bankAccount}
                                />
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.photo')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="photo"
                                    id="photo"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.photo}
                                />
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.foodHandlingCard')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="foodHandlingCard"
                                    id="foodHandlingCard"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.foodHandlingCard}
                                />
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.sexualCrimeCertification')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="sexualCrimeCertification"
                                    id="sexualCrimeCertification"
                                    readOnly
                                    checked={offerLetterData.sexualCrimeCertification}
                                />
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.workResidencyPermission')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="workResidencyPermission"
                                    id="workResidencyPermission"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.workResidencyPermission}
                                />
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.workLifeReport')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="workLifeReport"
                                    id="workLifeReport"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.workLifeReport}
                                />
                            </div>
                            <div className='my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.others')}</Form.Label>
                                <Form.Control
                                    className="me-3"
                                    as="textarea"
                                    name="otherDocumentation"
                                    id="otherDocumentation"
                                    onChange={handleOfferLetterChange}
                                    value={offerLetterData.otherDocumentation}
                                />
                            </div>
                        </>
                    }
                    {
                        offerLetterData.step === 2 &&
                        <>
                            <div>
                                {t('selection.candidateOfferLetterBenefits', {name: `${offerLetterSelectedChoose?.candidate?.firstname} ${offerLetterSelectedChoose?.candidate?.lastname}`})}
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.lifeOrAccidentsInsurance')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="lifeOrAccidentsInsurance"
                                    id="lifeOrAccidentsInsurance"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.lifeOrAccidentsInsurance}
                                />
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.continuousFormation')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="continuousFormation"
                                    id="continuousFormation"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.continuousFormation}
                                />
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.privateMedicalInsurance')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="privateMedicalInsurance"
                                    id="privateMedicalInsurance"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.privateMedicalInsurance}
                                />
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.foodDiscounts')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="foodDiscounts"
                                    id="foodDiscounts"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.foodDiscounts}
                                />
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.emotionalWelfarePrograms')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="emotionalWelfarePrograms"
                                    id="emotionalWelfarePrograms"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.emotionalWelfarePrograms}
                                />
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.schoolDiscounts')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="schoolDiscounts"
                                    id="schoolDiscounts"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.schoolDiscounts}
                                />
                            </div>
                            <div className='d-flex align-items-center my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.sportsFacilitiesDiscounts')}</Form.Label>
                                <Form.Check
                                    className="me-3"
                                    type="switch"
                                    name="sportsFacilitiesDiscounts"
                                    id="sportsFacilitiesDiscounts"
                                    onChange={handleOfferLetterSwitchChange}
                                    checked={offerLetterData.sportsFacilitiesDiscounts}
                                />
                            </div>
                            <div className='my-3'>
                                <Form.Label className="me-2 mt-2 mb-1 gris-label" htmlFor="work">{t('selection.offerLetterFields.others')}</Form.Label>
                                <Form.Control
                                    className="me-3"
                                    as="textarea"
                                    name="otherBenefits"
                                    id="otherBenefits"
                                    onChange={handleOfferLetterChange}
                                    value={offerLetterData.otherBenefits}
                                />
                            </div>
                        </>
                    }
                    {
                        offerLetterData.step === 3 &&
                        <>
                            <div style={{height: "70vh"}}>
                                <PDFViewer
                                    children={<OfferLetter selection={selection} choose={{...offerLetterSelectedChoose, offerLetter: offerLetterData}} school={{...school, image: schooluser?.image}}/>}
                                    style={{width: "100%", height: "100%"}}
                                />
                            </div>
                        </>
                    }
                    <Row className='my-3'>
                        <Col className='d-flex justify-content-end'>
                            <Button variant='secondary' className='me-2' onClick={handleOfferLetterModalClose}>{t('global.cancel')}</Button>
                            {
                                offerLetterData.step > 2
                                ?
                                    <Button variant='primary' onClick={handleSendOfferLetter}>
                                        {
                                            loading
                                            ?
                                                <span className="spinner-border spinner-border-sm align-middle ms-2"/>
                                            :
                                                t("global.save")
                                        }
                                    </Button>
                                :
                                    <Button variant='primary' onClick={() => handleOfferLetterChange({target: {name: "step", value: offerLetterData.step + 1}})}>
                                        {t("global.next")}
                                    </Button>
                            }
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal size='lg' show={incorporationDateSelectedChoose ? true : false} onHide={handleIncorporationDateModalClose}>
                <Modal.Header closeButton>
                    <h3>{t('selection.setIncorporationDate', {name: `${offerLetterSelectedChoose?.candidate?.firstname} ${offerLetterSelectedChoose?.candidate?.lastname}`})}</h3>
                </Modal.Header>
                <Modal.Body>
                    <div className='my-3'>
                        <Form.Label>{t("selection.incorporationDate")}</Form.Label>
                        <Form.Control type='date' value={incorporationDate || ""} onChange={({target}) => setIncorporationDate(target.value)}/>
                        {
                            incorporationDate && new Date(incorporationDate).getTime() < new Date().getTime()
                            ?
                                <div className='text-danger mt-2'>{t("selection.incorporationDateWarning")}</div>
                            :
                                <></>
                        }
                    </div>
                    <div className='my-3'>
                        <Form.Label>{t("selection.incorporationHour")}</Form.Label>
                        <Form.Control type='time' value={incorporationHour || ""} onChange={({target}) => setIncorporationHour(target.value)}/>
                    </div>
                    <Row className='my-3'>
                        <Col className='d-flex justify-content-end'>
                            <Button variant='secondary' className='me-2' onClick={handleIncorporationDateModalClose}>{t('global.cancel')}</Button>
                            <Button variant='primary' onClick={handleSetIncorporationDate}>
                                {
                                    loading
                                    ?
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"/>
                                    :
                                        t("global.save")
                                }
                            </Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal size='lg' show={multiSchoolStockForm ? true : false} aria-labelledby="example-custom-modal-styling-title" onHide={handleCloseStockModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("database." + (multiSchoolStockForm?.typeStock === "favourite" ? "addFavourite" : "addBlock"))}
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleStockSubmit}>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>{t('database.blockedScope')}</Form.Label>
                            <Form.Select
                                className='mb-2'
                                value={multiSchoolStockForm?.scope}
                                onChange={(e) => {
                                    setMultiSchoolStockForm({
                                        ...multiSchoolStockForm,
                                        scope: e.target.value
                                    })
                                }}
                            >
                                <option value="all">{t('database.allSchools')}</option>
                                <option value="current">{t('database.currentSchool', {school: school?.name})}</option>
                            </Form.Select>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type='button' className='btn btn-secondary' onClick={handleCloseStockModal}>
                            {t('global.cancel')}
                        </button>
                        <button className='btn btn-primary' type='submit'>
                            {t('global.save')}
                        </button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}